import React, { useEffect, useState } from "react";
import SEO from "../components/SEO";
import { submitContactForm } from "../api/apiClient";
import { toast } from "react-hot-toast";
import FAQ from "../components/FAQ";

const PartnerWithUs = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    city: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.length > 255) {
      newErrors.name = "Name must be less than 255 characters";
    }

    if (formData.email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    if (formData.mobile_number) {
      const phoneRegex = /^[6-9]\d{9}$/;
      if (!phoneRegex.test(formData.mobile_number.replace(/\D/g, ""))) {
        newErrors.mobile_number = "Please enter a valid 10-digit mobile number";
      }
    }

    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        mobile_number: formData.mobile_number,
        message: `Partner Enquiry. City: ${formData.city}`,
      };

      const response = await submitContactForm(payload);

      if (response && response.status) {
        toast.success(response.message || "Message sent successfully");
        setFormData({
          name: "",
          email: "",
          mobile_number: "",
          city: "",
        });

        if (window.jQuery && window.$) {
          window.$("#exampleModal").modal("hide");
        }
      } else {
        toast.error("Failed to send message");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="partner-page">
      <SEO
        title="Partner With Us"
        description="Join Gateway Financial as a business partner, sub-broker, or financial advisor. Leverage our established market expertise and infrastructure to grow your business."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: 'url("images/partner-with-us-bg.jpg")',
              }}
            >
              <canvas id="canvas" />
              <div className="carousel-caption">
                <h1 className="mb-lg-5 mb-xl-5">Partner With Us</h1>
                <a
                  href="#exampleModal"
                  className="btn2"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  Become a Partner
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal Form */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog cus_modal" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Talk To Experts
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="popup-form" onSubmit={handleSubmit}>
                <div className="controls">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          id="form_name"
                          type="text"
                          name="name"
                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                          placeholder="Enter Name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div
                            className="invalid-feedback"
                            style={{
                              display: "block",
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          id="form_email"
                          type="email"
                          name="email"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          placeholder="Enter Your Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div
                            className="invalid-feedback"
                            style={{
                              display: "block",
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.email}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          id="form_phone"
                          type="tel"
                          name="mobile_number"
                          className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                          placeholder="Enter Mobile Number"
                          value={formData.mobile_number}
                          onChange={handleChange}
                        />
                        {errors.mobile_number && (
                          <div
                            className="invalid-feedback"
                            style={{
                              display: "block",
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.mobile_number}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          id="form_city"
                          type="text"
                          name="city"
                          className={`form-control ${errors.city ? "is-invalid" : ""}`}
                          placeholder="Enter City"
                          value={formData.city}
                          onChange={handleChange}
                        />
                        {errors.city && (
                          <div
                            className="invalid-feedback"
                            style={{
                              display: "block",
                              color: "#dc3545",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {errors.city}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12 fm-ctn">
                      <p>
                        By submitting the form you are authorising Gateway
                        Financial to call you and send promotional communication
                        even though you being registered under DNC.
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <input
                        type="submit"
                        className="lm-btn"
                        value={isSubmitting ? "Submitting..." : "Continue"}
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <h2>Why Partner With Us?</h2>
              <p className="spc-txt mb-0">
                Partner With Us is a collaborative program designed for
                professionals, financial advisors, and business associates who
                want to grow their business by offering trusted financial and
                investment services to their clients. At GFSL, we believe strong
                partnerships create stronger financial outcomes. Our partnership
                model enables individuals and organizations to leverage our
                decades of market experience, research-driven insights, and
                reliable infrastructure to deliver value to investors.
              </p>
              <p>
                By partnering with us, you gain access to a comprehensive
                ecosystem that includes equity trading, portfolio advisory,
                research support, and client servicing assistance. We empower
                our partners with the tools, knowledge, and operational support
                required to build long-term relationships with investors while
                expanding their own revenue opportunities. Whether you are an
                independent advisor, wealth consultant, or business network
                looking to diversify your offerings, our partnership program
                helps you scale with confidence while maintaining a client-first
                approach.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="invested-section">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center mb-3">
              <h3>Why Choose a Partnership with GFSL?</h3>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-4">
              <div className="invest-box text-center pwu-min-height">
                <img
                  src="images/op-icon1.png"
                  className="img-fluid"
                  alt="Attractive Revenue Opportunities"
                />
                <h4>Attractive Revenue Opportunities</h4>
                <p className="mb-0">
                  The partnership program is designed to create sustainable
                  income streams for partners. Through transparent
                  revenue-sharing models and scalable business opportunities,
                  partners can grow their financial practice while delivering
                  quality services to investors.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center pwu-min-height">
                <img
                  src="images/op-icon2.png"
                  className="img-fluid"
                  alt="Reliable Operational and Client Support"
                />
                <h4>Reliable Operational and Client Support</h4>
                <p className="mb-0">
                  GFSL ensures smooth onboarding, account management, and client
                  servicing support. Our experienced team assists partners in
                  handling operational processes efficiently, allowing them to
                  focus on client engagement and business growth.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center pwu-min-height">
                <img
                  src="images/op-icon3.png"
                  className="img-fluid"
                  alt="Long-Term Growth Collaboration"
                />
                <h4>Long-Term Growth Collaboration</h4>
                <p className="mb-0">
                  At GFSL, partnerships are built on trust and mutual growth. We
                  work closely with our partners to expand their business
                  networks, strengthen investor relationships, and build a
                  long-term financial advisory practice backed by a trusted
                  brokerage brand.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="invest-box text-center pwu-min-height">
                <img
                  src="images/op-icon4.png"
                  className="img-fluid"
                  alt="Established Market Expertise"
                />
                <h4>Established Market Expertise</h4>
                <p className="mb-0">
                  With over three decades of experience in the financial
                  markets, GFSL brings deep industry knowledge and proven market
                  understanding. Partners benefit from insights shaped by
                  multiple market cycles, enabling them to guide clients with
                  confidence and credibility.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center pwu-min-height">
                <img
                  src="images/op-icon5.png"
                  className="img-fluid"
                  alt="Comprehensive Investment Solutions"
                />
                <h4>Comprehensive Investment Solutions</h4>
                <p className="mb-0">
                  GFSL provides access to a wide range of financial products
                  including equities, derivatives, mutual funds, and portfolio
                  advisory services. This allows partners to offer diversified
                  investment opportunities and meet the varied financial goals
                  of their clients under one trusted platform.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="invest-box text-center pwu-min-height">
                <img
                  src="images/op-icon6.png"
                  className="img-fluid"
                  alt="Strong Research and Market Insights"
                />
                <h4>Strong Research and Market Insights</h4>
                <p className="mb-0">
                  Our dedicated research support helps partners stay ahead of
                  market trends with timely insights, investment ideas, and
                  sector analysis. This empowers partners to make informed
                  recommendations and strengthen their client relationships
                  through value-added advisory.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="service-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 text-center mb-3">
              <h3>Who Can Become Our Partner?</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="images/op-icon11.png"
                  className="img-fluid"
                  alt="Sub-Brokers and Authorized Persons"
                />
                <h4>Sub-Brokers and Authorized Persons</h4>
                <p>
                  Existing sub-brokers or market intermediaries who want to
                  associate with a trusted brokerage house can leverage GFSL’s
                  infrastructure, research support, and brand credibility to
                  grow their business.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="images/op-icon22.png"
                  className="img-fluid"
                  alt="Business Owners and Entrepreneurs"
                />
                <h4>Business Owners and Entrepreneurs</h4>
                <p>
                  Individuals with strong local networks and an interest in the
                  financial markets can build a new revenue stream by
                  introducing clients to GFSL’s investment and trading services.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="images/op-icon33.png"
                  className="img-fluid"
                  alt="Financial Institutions and Professional Networks"
                />
                <h4>Financial Institutions and Professional Networks</h4>
                <p>
                  Organizations such as advisory firms, consultancy groups, or
                  financial service providers can partner with GFSL to enhance
                  their client offerings with reliable broking and advisory
                  solutions.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="images/op-icon44.png"
                  className="img-fluid"
                  alt="Independent Financial Advisors (IFAs)"
                />
                <h4>Independent Financial Advisors (IFAs)</h4>
                <p>
                  Professionals who already advise clients on investments,
                  mutual funds, or financial planning can partner with GFSL to
                  expand their offerings into equity trading, portfolio
                  strategies, and broader market opportunities.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="images/op-icon55.png"
                  className="img-fluid"
                  alt="Wealth Managers and Investment Consultants"
                />
                <h4>Wealth Managers and Investment Consultants</h4>
                <p>
                  Individuals or firms engaged in wealth advisory can
                  collaborate with GFSL to provide clients with a reliable
                  trading platform, research insights, and diversified
                  investment solutions.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="serv-box text-center">
                <img
                  src="images/op-icon6.png"
                  className="img-fluid"
                  alt="Chartered Accountants and Tax Consultants"
                />
                <h4>Chartered Accountants and Tax Consultants</h4>
                <p>
                  CAs and tax professionals often work closely with clients on
                  financial matters. Partnering with GFSL enables them to
                  complement their services by offering structured investment
                  opportunities and market access.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a
                href="#download"
                onClick={(e) => e.preventDefault()}
                className="lm-btn"
              >
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="images/app-pic.jpg"
                className="img-fluid"
                alt="Mobile App Preview"
              />
            </div>
          </div>
        </div>
      </section>
      <FAQ />
    </div>
  );
};

export default PartnerWithUs;
